import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';

class Demo extends React.Component {
  render() {
    return (
      <Container>
        <Text>
          {this.props.Demo1}
          <br />
          {this.props.Demo2}
        </Text>
        <Button>
          <Link
            to="contact"
            spy
            smooth
            duration={500}
            style={{
              height: '100%',
              width: '100%',
              cursor: 'pointer',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
            offset={-70}
          >
            {this.props.DemoCall}
          </Link>
        </Button>
      </Container>
    );
  }
}

export default Demo;

const Container = styled.div`
  width: 100vw;
  /* height: 70vh; */
  background: #262936;
  /* background: linear-gradient(to top, #262936, #243b55); */
  color: #4babc0;
  padding: 4rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Text = styled.div`
  font-size: 35px;
  line-height: 35px;
  letter-spacing: 2px;
  text-align: center;
  @media (max-width: 950px) {
    font-size: 25px;
    padding: 0 50px;
  }
`;

const Button = styled.button`
  width: 250px;
  height: 60px;
  background: #4babc0;
  background: #667db6; /* fallback for old browsers */
  background: linear-gradient(to right, #4babc0, #0082c8);
  font-size: 25px;
  line-height: 25px;
  margin-top: 25px;
  color: white;
  display: flex;
  justify-content: center;
  border-radius: 35px;
  align-items: center;
  cursor: pointer;
  border: none;
  transition: 0.5s ease-out;
  &:focus {
    outline: none;
    border: none;
  }
  &:hover {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  }
`;



// WEBPACK FOOTER //
// ./src/components/Demo/index.js